import React, { useCallback, useEffect, useRef, useState } from 'react'
import { KeenIcon, DefaultTooltip } from '@/components';
import { useSettings } from '@/providers';
import { DocumentUploadModal, DocumentPreviewModal } from '@/components/modal';
import { formatDueDate, isPastDue } from '@/components/modal/esignTracking';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { goTo403 } from "@/utils/Navigation";
import { createDataTableOptions, createDataTableConfig, triggerDownload, FiltersToFormData, getAccessToken } from '@/utils';
import matterService from '@/services/matter/matterService';
import { toast } from 'sonner';
import uploadDocumentService from '@/services/document/uploadDocumentService';
import { createRoot } from 'react-dom/client';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useAbility } from '@/providers/';
import { Can } from '@casl/react';
import { Button } from "@/components/ui/button";
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { useAuthContext } from '@/auth';
import eSignatureService from '../../services/e-signature/eSignatureService';

DataTable.use(DT);
const ContactDocumentSignature = ({ contactData, contactId }) => {
  const { logout } = useAuthContext();
  const { getThemeMode } = useSettings();
  const [documentModal, setDocumentModal] = useState(false);
  const [uploadDocumentLoading, setUploadDocumentLoading] = useState(false)
  const [uploadedFile, setUploadedFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const tableRef = useRef(null);
  const API_URL = import.meta.env.VITE_APP_BASE_URL;
  const token = getAccessToken();
  const [filterData, setFilterData] = useState({
    recipient_type: 'App\\Models\\Contact',
    recipient_id: contactId,
  });
  const filterRef = useRef(filterData);
  const [uploadErrors, setUploadErrors] = useState({});
  const [docUploadModal, setDocUploadModal] = useState(false);
  const [resetChildState, setResetChildState] = useState(false);
  const { ability } = useAbility();
  const canEditContact = ability.can('handle', 'contact')
  const [showDocumentPreviewModal, setShowDocumentPreviewModal] = useState(false)
  const [documentPreviewRes, setDocumentPreviewRes] = useState(null)
  const [previewLoading, setPreviewLoading] = useState(false)
  const [selectedSigners, setSelectedSigners] = useState([]);
  const [showSignersModal, setShowSignersModal] = useState(false);
  const zoomPluginInstance = zoomPlugin();
  const [selectedContact, setSelectedContact] = useState(false)

  const formatSignerDateTime = useCallback((value) => {
    if (!value) return '-';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours24 = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const hours12 = hours24 % 12 || 12;
    const meridiem = hours24 >= 12 ? 'PM' : 'AM';

    return `${month}/${day}/${year} ${hours12}:${minutes} ${meridiem}`;
  }, []);


  const handleClosePreviewDocModal = () => {
    setShowDocumentPreviewModal(false)
    setDocumentPreviewRes('')
  }

  const handleOpenSignersModal = useCallback((row) => {
    setSelectedSigners(Array.isArray(row?.signers) ? row.signers : []);
    setShowSignersModal(true);
  }, []);

  const handleCloseSignersModal = useCallback(() => {
    setShowSignersModal(false);
    setSelectedSigners([]);
  }, []);

  useEffect(() => {
    filterRef.current = filterData;
  }, [filterData]);

  const refresh = () => {
    const table = tableRef.current.dt();
    table.ajax.reload();
  };

  const handleUploadDocument = async (values) => {
    // console.log({values: values.fields});
    // return
    if (!contactData?.email?.trim()) {
      toast.warning('Missing Email Address', {
        description: 'This contact has no email. Please add one before proceeding.',
      });
      return
    }
    const formData = new FormData();
    formData.append('file', values.file);
    formData.append('coordinates', JSON.stringify(values.fields));
    formData.append('id', contactId);
    formData.append('type', 'contact');
    formData.append('email_subject', values.email_subject);
    formData.append('message', values.message);
    if (values.due_date) formData.append('due_date', values.due_date);

    setUploadDocumentLoading(true);
    console.log(uploadDocumentLoading)
    // return
    try {
      const { status } = await eSignatureService.uploadDocForSignature(formData);
      if (status) {
        refresh();
        toast.success('Document Sent', {
          description: 'The document was successfully sent to the contact for signature via email.',

        });
        handleCloseDocumentModal();
        setResetChildState(true);
        setTimeout(() => setResetChildState(false), 0);
      }
    } catch (error) {
      console.error('Error', error);
      if (error?.data?.message === '422 Unprocessable Entity. Validation failed.') {
        console.log('asd');

        const serverErrors = error.data.errors;

        const formattedErrors = Object.keys(serverErrors).reduce((acc, key) => {
          acc[key] = serverErrors[key][0];
          return acc;
        }, {});

        setUploadErrors(formattedErrors);

        toast.error('Some files failed validation.', {
          description: 'Please review the errors below and try again.',
        });

        return;
      }
      // Any other failure (a contact without an email, the email not going out) used to show nothing.
      toast.error('The document was not sent.', {
        description: error?.data?.data?.error || error?.data?.message || 'Please try again in a moment.',
      });
    } finally {
      setUploadDocumentLoading(false);
    }
  };

  const handleCloseDocumentModal = () => {
    setDocumentModal(false);
    setDocUploadModal(false) // close Email/Sub modal
    setTimeout(() => setResetChildState(false), 0);
    // setUploadedFile(null);
    // setFileData([])
    // setServerErrors([]);
    // setFileError(null);
  }

  const badgeClasses = {
    completed: 'badge-success',
    partially_signed: 'badge-info',
    signed: 'badge-success',
    sent: 'badge-warning',
    in_progress: 'badge-info',
    pending: 'badge-warning',
  };

  const columns = [
    // {
    //   title: 'S#',
    //   name: 'serial',
    //   data: null,
    //orderable: true,se,
    //   render: (data, type, row, meta) => meta.row + 1,
    // },
    {
      data: 'document_name',
      title: 'Document Name',
      name: 'document_name',
      render: function (data, type, row) {
        return `<div class="w-[180px] whitespace-pre-wrap truncate" id="document-name-cell-${row.id}"></div>`;
      }
    },
    {
      data: 'status',
      title: 'Status',
      name: 'status',
      render: function (value) {
        if (!value) return '-';
        return `<span class="capitalize badge badge-pill badge-outline ${badgeClasses[value]} gap-1 items-center">
              <span class="badge badge-dot size-1.5 ${badgeClasses[value]}"></span>
              ${value.split('_').join(' ')}
          </span>`;
      }
    },
    {
      data: 'sent_at',
      title: 'Sent At',
      name: 'sent_at',
      className: '!text-start',
    },
    // {
    //   data: 'signatory_name',
    //   // className: 'word-break-break-word',
    //   title: 'Signatory Name',
    //   render: function (value, data, row) {
    //     return value || '-';
    //   }
    // },
    {
      data: 'updated_at',
      title: 'Date Signed On',
      render: function (value, data, row) {
        console.log('data', data, value, row)
        if (row.status === 'pending') return '-';
        else return value;
      }
    },
    {
      data: 'signers',
      title: 'Signers',
      name: 'signers',
      orderable: false,
      searchable: false,
      render: function (data, type, row) {
        return `<div id="signers-cell-${row.id}"></div>`;
      }
    },
    {
      data: 'due_at',
      title: 'Sign By',
      name: 'due_at',
      render: function (value, type, row) {
        if (!value) return '-';
        const overdue = row.status !== 'signed' && isPastDue(value);
        return `<span class="${overdue ? 'text-danger font-medium' : ''}">${formatDueDate(value)}${overdue ? ' (overdue)' : ''}</span>`;
      }
    },
    {
      title: 'Actions',
      data: null,
      orderable: true,
      searchable: false,
      render: function (data, type, row) {
        return `<div id="action-cell-${row.id}"></div>`;
      }
    }
  ];

  const ajaxConfig = createDataTableConfig('/documents/e-sign/data-table', filterRef, token, logout);

  const options = createDataTableOptions({
    order: [[4, 'desc']],
    drawCallback: function () {
      const api = this.api();
      const rows = api.rows({ page: 'current' }).data();

      rows.each((row) => {
        const actionContainer = document.getElementById(`action-cell-${row.id}`);
        if (actionContainer) {
          if (!actionContainer._reactRoot) {
            actionContainer._reactRoot = createRoot(actionContainer);
          }
          actionContainer._reactRoot.render(renderCustomActions(row));
        }
        const documentContainer = document.getElementById(`document-name-cell-${row.id}`);
        if (documentContainer) {
          if (!documentContainer._reactRoot) {
            documentContainer._reactRoot = createRoot(documentContainer);
          }
          documentContainer._reactRoot.render(renderDocumentPreview(row));
        }
        const signersContainer = document.getElementById(`signers-cell-${row.id}`);
        if (signersContainer) {
          if (!signersContainer._reactRoot) {
            signersContainer._reactRoot = createRoot(signersContainer);
          }
          signersContainer._reactRoot.render(renderSignersCell(row));
        }
      })
    }
  });

  const renderDocumentPreview = (row) => {
    const { id, document_name, status } = row;
    return (
      <span onClick={() => { handleToggleDocPreview(id, row) }} className={`${'cursor-pointer link'}`}>
        <DefaultTooltip title={document_name} placement="top">
          {document_name}
        </DefaultTooltip>
      </span>
    )
  }

  const renderSignersCell = (row) => {
    const signers = Array.isArray(row?.signers) ? row.signers : [];
    const signedCount = signers.filter((signer) => signer?.status === 'signed').length;

    return (
      <button
        type="button"
        onClick={() => handleOpenSignersModal(row)}
        className="link text-xs"
      >
        {signers.length ? `${signedCount}/${signers.length} Signers` : 'View Signers'}
      </button>
    );
  };

  const handleToggleDocPreview = async (id, row) => {

    setPreviewLoading(true);
    setShowDocumentPreviewModal(true);

    try {
      const blob = row.status === 'pending' ? await eSignatureService.downloadSignDocument(id, 'preview') : await eSignatureService.downloadSignDocument(id, 'preview');

      console.log("blob -->", blob, blob.type);

      // Convert blob to previewable URL
      const objectUrl = URL.createObjectURL(blob);

      setDocumentPreviewRes({
        url: objectUrl,
        type: blob.type,        // "image/png", "application/pdf", etc.
      });


    } catch (error) {
      console.error("Error", error);
    } finally {
      setPreviewLoading(false);
    }
  };

  const renderCustomActions = (row) => {
    console.log('row', row);

    const { status, document_name, recipient, id } = row;

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="text-gray-600">
            <KeenIcon icon="dots-vertical" className="text-[18px]" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-52">
          {status !== 'sent' && canEditContact && (
            <DropdownMenuItem onClick={() => handleDownload(id, document_name, recipient)}>
              <KeenIcon icon="exit-up" className="mr-0.5 h-4 w-4 cursor-pointer" /> Download Document
            </DropdownMenuItem>
          )}
          {canEditContact && (status !== 'completed' && status !== 'signed') && (
            <DropdownMenuItem onClick={() => handleResendDocument(id)}>
              <KeenIcon icon="notification-on" className="mr-0.5 h-4 w-4 cursor-pointer" /> Send Reminder
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  };

  const handleResendDocument = async (id) => {
    try {
      const { status, message } = await eSignatureService.remindDocument(id);
      if (status) {
        refresh();
        toast.success(message || 'Reminder sent.');
      }
    } catch (error) {
      console.error('Error', error);
      toast.error(error?.error || 'Could not send the reminder. Please try again in a moment.');
    }
  };

  const handleDownload = async (token, document_name, recipient) => {
    try {
      // Call your service – make sure it returns file data (Blob/ArrayBuffer)
      const response = await eSignatureService.downloadSignDocument(token);
      console.log('response', response);

      if (response) {
        // Create a blob from the response
        const blob = new Blob([response], { type: 'application/pdf' });

        const file_name = `${recipient.fullName} - ${document_name}`;
        triggerDownload(blob, file_name);

        toast.success('Document has been downloaded.');
        // refresh();
      } else {
        toast.error('No document data found.');
      }
    } catch (error) {
      console.error('Error', error);
      toast.error('Oops! Something went wrong.', {
        description:
          'An error occurred while downloading document. Please try again in a moment.',
      });
    }
  };


  return (
    <>
      <div className='mb-4 card'>
        <div className="card-header !block">
          <div className='flex flex-wrap items-center justify-between'>
            <h3 className="card-title">Documents</h3>

            <div className='flex flex-wrap items-center gap-2'>
              {contactData.status === 'active' && (
                <button className='text-xs btn btn-sm btn-light btn-outline' onClick={() => setDocumentModal(true)}>
                  <KeenIcon icon="exit-up" className="w-fit btn-icon" />
                  Upload Document
                </button>
              )}
            </div>
          </div>
        </div>
        <DataTable
          id="documents-table"
          ajax={ajaxConfig}
          columns={columns}
          options={options}
          ref={tableRef}
        />
      </div>
      <DocumentUploadModal
        show={documentModal}
        showEmailModal={docUploadModal}
        onClose={() => setDocumentModal(false)}
        onConfirm={handleUploadDocument}
        Data={contactData}
        module='contact'
        title='Upload Document'
        loading={uploadDocumentLoading}
        errors={uploadErrors}
        data={contactData}
        resetChildState={resetChildState}
      />
      <DocumentPreviewModal
        open={showDocumentPreviewModal}
        onClose={handleClosePreviewDocModal}
        fileUrl={documentPreviewRes?.url}
        loading={previewLoading}
        title="Preview Document"
        zoomPluginInstance={zoomPluginInstance}
      />
      {showSignersModal && (
        <div className='modal-wrapper modal-animate-fade'>
          <div className="modal-body w-full max-w-4xl animate-scale">
            <div className="flex items-center justify-between mb-5">
              <h3 className="card-title">Signers</h3>
              <button
                type="button"
                onClick={handleCloseSignersModal}
                className="modal-close-btn"
              >
                <KeenIcon icon="cross" />
              </button>
            </div>

            <div className="overflow-x-auto">
              <table className="table table-auto text-sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Sign Order</th>
                    <th>Status</th>
                    <th>Sent At</th>
                    <th>Signed At</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedSigners.length ? selectedSigners.map((signer) => (
                    <tr key={signer.uuid || `${signer.email}-${signer.order_number}`}>
                      <td>{signer.name || '-'}</td>
                      <td>{signer.email || '-'}</td>
                      <td>{signer.order_number ?? '-'}</td>
                      <td className="capitalize">{signer.status || '-'}</td>
                      <td>{formatSignerDateTime(signer.sent_at)}</td>
                      <td>{formatSignerDateTime(signer.signed_at)}</td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan={6} className="text-center py-4 text-gray-500">
                        No signers found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export { ContactDocumentSignature }
